import React from 'react';
import BaseComponent from './BaseComponent';
import Event from './Event';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import classNames from 'classnames';
import {List, ListItem, ListBody, ListTitle} from './UIList';

export class PureAccompanistList extends BaseComponent {
    render() {
        const {entries, selectedAccompanist} = this.props;
        const accompanists = entries.map(e => e.accompanist).toSet().sort();

        return <div className="accompanist-list">
            <List>
                {accompanists.map(accompanist => {
                    const path = `/accompanist/${accompanist}`;
                    const active = selectedAccompanist === accompanist;
                    return <ListItem active={active} key={accompanist} to={path}>
                        <ListBody><ListTitle>{accompanist}</ListTitle></ListBody>
                    </ListItem>;
                })}
            </List>
        </div>;
    }
}

function mapStateToProps({app}) {
    return {entries: app.get('entries')};
}

export default connect(mapStateToProps)(PureAccompanistList);



/** WEBPACK FOOTER **
 ** ./src/components/AccompanistList.jsx
 **/